import React from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons/faCircleNotch';

import { noop } from 'buyside/util/lodashAlt';

import styles from './feedFilterPanelStyles.scss';

export const filterOps = ['ALL', 'IDEAS'];

const FeedFilterPanel: React.FC<{
  feedFilter: string;
  setFilter: () => void;
  isLoading: boolean;
}> = ({ feedFilter, setFilter, isLoading }): React.ReactElement => (
  <div className={styles.feedFilter}>
    <span
      id={filterOps[0]}
      className={classNames(styles.filterFeedButton, {
        [styles.filterFeedSelected]: feedFilter === filterOps[0]
      })}
      onClick={isLoading ? noop : setFilter}
    >
      All Content
      {isLoading && feedFilter === filterOps[0] && <FontAwesomeIcon icon={faCircleNotch} spin />}
    </span>
    <span
      id={filterOps[1]}
      className={classNames(styles.filterFeedButton, {
        [styles.filterFeedSelected]: feedFilter === filterOps[1]
      })}
      onClick={isLoading ? noop : setFilter}
    >
      Ideas Only
      {isLoading && feedFilter === filterOps[1] && <FontAwesomeIcon icon={faCircleNotch} spin />}
    </span>
  </div>
);

export default FeedFilterPanel;
